// Native Prismic & Imgix
export const reactPlayerGiffer = (url) => {
  return [
    {
      src: `${url}&fm=mp4`,
      type: 'video/mp4',
    },
    {
      src: `${url}&fm=webm`,
      type: 'video/webm',
    },
  ];
};
// export const reactPlayerGiffer = url => {
//   const encodedUrl = encodeURI(url);
//   // const encodedUrl = encodeURI(url.split('?')[0]);

//   // With Netlify Proxy
//   // const cloudinaryBase = 'https://www.riffrafffilms.tv/cloudinary/';

//   // With Cloudflare and Netlify Proxy
//   const cloudinaryBase = 'https://riffraff.coucouapp.com/cloudinary/';

//   // Direct
//   // const cloudinaryBase = 'https://res.cloudinary.com/riffrafffilms/image/fetch/';

//   return [
//     {
//       src: `${cloudinaryBase}f_mp4/${encodedUrl}`,
//       type: 'video/mp4'
//     },
//     {
//       src: `${cloudinaryBase}f_webm/${encodedUrl}`,
//       type: 'video/webm'
//     },
//     { src: `${cloudinaryBase}f_ogg/${encodedUrl}`, type: 'video/ogg' }
//   ];
// };
